





















import { Vue } from "vue-property-decorator";

export default class SysMaintain extends Vue {}

